export default __webpack_public_path__ + "static/media/england.e9b060cd.svg";